function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 669.922,
    height: 565.317,
    viewBox: "0 0 177.25 149.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.938 79.006c-1.86 8.062-2.48 18.914-2.48 26.355 0 60.875 36.483 100.976 92.5 100.976 38.138 0 53.95-22.944 56.948-27.285l-11.266-.93c10.75 11.162 15.917 23.874 21.084 39.894 1.24 3.927 3.928 5.27 6.822 5.27 5.994 0 11.162-5.167 11.162-12.505 0-10.955-16.64-30.386-25.115-38.344C132.626 139.364 76.919 159.001 64 122.104c-.93-2.79 2.067-5.27 4.857-2.48 28.32 28.318 64.906 4.444 99.736 36.587 2.997 2.687 6.511 1.24 7.028-1.86.413-2.171.62-5.892.62-9.406 0-39.997-28.009-59.531-66.973-59.531-13.229 0-28.939 3.617-40.927 3.617-12.196 0-26.769-.62-38.861-13.022-3.617-3.617-9.095-3.204-10.542 2.997z",
    className: "monochrome-0 multicolor-0:systemGreenColor SFSymbolsPreview28CD41",
    style: {
      fill: "#28cd41",
      strokeWidth: 2.11666
    },
    transform: "translate(-16.457 -73.713)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.8c657ece0a6e0447f118952de78f8be2.svg";
export { ForwardRef as ReactComponent };